import { render, staticRenderFns } from "./CrmSaleEvent.vue?vue&type=template&id=21f459cc"
import script from "./CrmSaleEvent.vue?vue&type=script&lang=ts"
export * from "./CrmSaleEvent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f459cc')) {
      api.createRecord('21f459cc', component.options)
    } else {
      api.reload('21f459cc', component.options)
    }
    module.hot.accept("./CrmSaleEvent.vue?vue&type=template&id=21f459cc", function () {
      api.rerender('21f459cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crm/events/CrmSaleEvent.vue"
export default component.exports